import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * Shown when a screen's data failed to load. Crew are often on poor site signal,
 * so a failed request must say so and offer a retry -- the alternative (render
 * nothing, or spin forever) reads as "the app is broken" with no way forward.
 */
export default function LoadError({ message, onRetry, testId = "load-error" }) {
    return (
        <div className="p-6 max-w-md mx-auto text-center" data-testid={testId}>
            <div className="bg-white rounded-2xl border border-brand-danger/30 shadow-card p-6">
                <AlertTriangle className="h-8 w-8 text-brand-danger mx-auto" />
                <div className="font-bold text-lg text-brand-charcoal mt-3">Couldn’t load this screen</div>
                <div className="text-sm text-brand-charcoal/70 mt-1">
                    {message || "Something went wrong. Check your signal and try again."}
                </div>
                {onRetry && (
                    <button
                        onClick={onRetry}
                        className="mt-4 inline-flex items-center gap-2 bg-brand-charcoal text-brand-bone rounded-xl px-5 py-3 font-bold hover:bg-brand-charcoal/90"
                        data-testid={`${testId}-retry`}
                    >
                        <RefreshCw className="h-4 w-4" /> Try again
                    </button>
                )}
            </div>
        </div>
    );
}
